const noop = require('mn-utils/noop');
const upperFirst = require("mn-utils/upperFirst");

module.exports = ({formCtx, ...props}) => {
  if (!formCtx) return {...props};

  const {
    id: manualId,
    label: manualLabel,
    disableLabel,
    name,
    disabled: manualDisable,
    ...rest
  } = props;

  const {data, loading, click, errors} = (formCtx.state || {});

  let isRequired = false;

  if (formCtx.props.schema) {
    const field = formCtx.props.schema.fields[name] || {};
    const exclusiveTests = {...(field.exclusiveTests || {})};

    isRequired = exclusiveTests.hasOwnProperty('required');
  }

  const disabled = manualDisable || loading;

  const value = data[name];
  const error = errors[name];
  const onChange = disabled ? noop : formCtx.onChange;
  const onManualChange = disabled ? noop : formCtx.onManualChange;

  const id = manualId || name;

  const label = disableLabel
    ? ''
    : manualLabel
      ? manualLabel
      : name
        ? name.split('_').map(upperFirst).join(' ')
        : '';

  const showError = click && error;

  return {id, label, name, value, disabled, isRequired, error, showError, onChange, onManualChange, ...rest};
};
